export default __webpack_public_path__ + "static/media/grafema_ummi_01.9f5510db.jpg";